import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type VideoModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  poster: string;
};
export function VideoModal({
  open,
  onClose,
  title,
  description,
  poster
}: VideoModalProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-609" data-mp="2lwywa7r6a8f8">
      {open && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/85 px-4 py-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={onClose} role="dialog" aria-modal="true" aria-label={title} data-id="element-610" data-mp="2ly1nyhwbkew7">
          <motion.div className="relative w-full max-w-4xl overflow-hidden rounded-media bg-black" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={event => event.stopPropagation()} data-id="element-611" data-mp="37p4v5gxgyv1o">
            <button ref={closeRef} type="button" onClick={onClose} aria-label="Close video" className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black/60 text-white transition-colors duration-150 ease-emphasis hover:bg-black/80" data-id="element-612" data-mp="2oslttdswqbfo">
              <XIcon aria-hidden className="h-5 w-5" data-id="element-613" data-mp="pkn68b3xp6m1" />
            </button>
            <div className="relative aspect-video w-full" data-id="element-614" data-mp="lhh4ngrro3lw">
              <img src={poster} alt="" className="h-full w-full object-cover opacity-60" data-id="element-615" data-mp="lk3btfaqwh3l" />
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center" data-id="element-616" data-mp="bkm8h4iyufas">
                <p className="font-display text-2xl text-white sm:text-3xl" data-id="element-617" data-mp="1969sepy8j55f">{title}</p>
                <p className="max-w-md text-sm text-white/70" data-id="element-618" data-mp="1488cgdw3vly6">{description}</p>
                <p className="mt-2 text-xs uppercase tracking-[0.14em] text-white/50" data-id="element-619" data-mp="zhi2encqiux5">
                  Video with captions and transcript
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}